<template>
  <div>
    <div class="col-md-12" style="padding-left: 5%; padding-right: 5%;">
      <div class="bg-plans-form mt-10">
        <h2>
          จัดการข้อมูลทีม
        </h2>
        <br />
        <b-button variant="success" @click="teamActionModal()">+ เพิ่มทีม</b-button>
        <table ref="table_1" id="table_1" class="display" style="width:100%">
        </table>
      </div>
    </div>
    <b-modal id="teamCreateForm" ref="teamActionModal" centered no-enforce-focus size="lg" title="เพิ่มทีม">
      <label class="mr-sm-2">ชื่อทีม</label>
      <b-form-input v-model="teamCreateForm.teamName" size="sm"></b-form-input>
      <label class="mr-sm-2">สีประจำทีม</label>
      <compact-picker v-model="teamColor" />
      <template #modal-footer="{ cancel }">
        <b-button variant="primary" @click="confirmActionteam()">
          ยืนยีน
        </b-button>
        <b-button variant="danger" @click="cancel()">
          ยกเลิก
        </b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import FetchService from "@/core/services/fetch.service";
import DataTable from 'datatables.net-bs4';
import "datatables.net-bs4/css/dataTables.bootstrap4.css";
import 'datatables.net-rowgroup-bs4';
import 'datatables.net-rowgroup-bs4/css/rowGroup.bootstrap4.css';
import 'datatables.net-buttons-bs4';
import 'datatables.net-buttons-bs4/css/buttons.bootstrap4.css';
import $ from "jquery";
import Swal from 'sweetalert2'
import { Compact } from 'vue-color'
export default {
  components: {
    'compact-picker': Compact,
  },
  data() {
    return {
      masterDataTable: {},
      dataTable: [],
      masterData: [],
      teamCreateForm: {
        teamName: "",
      },
      teamEditMode: 0,
      teamIdSelect: "",
      formSetting: {
        teamData: "",
      },
      teamColor: "#FFFFFF",
    };
  },
  mounted() {
    setTimeout(() => {
      this.getDataTable()
    }, 100)
  },
  methods: {
    getDataTable() {
      if (this.masterDataTable?.destroy) {
        this.masterDataTable.destroy()
      }
      FetchService.get("/getteam", (response) => {
        if (response) {
          response = JSON.parse(response)
          console.log("response", response)
          this.masterData = []
          this.masterData = response.thisTeam
          this.pageInit()
        }
      })
    },
    pageInit() {

      let that = this

      let arrTable = this.masterData.map((row, index) => {
        return [
          row?._id ? row._id : "",
          row?.name ? row.name : "",
          `<div style="background-color: ${row.color ? row.color : "#FFFFFF"};width: 100%;height: 40px;"></div>`,
          `<button type="button" class="btn btn-warning mr-4 btn-edit" style="cursor: pointer" value="${row?._id}">แก้ไข</button> <button type="button" class="btn btn-danger mr-4 btn-del" style="cursor: pointer" value="${row?._id}">ลบ</button>`,
        ]
      })

      this.masterDataTable = new DataTable('#table_1', {
        data: arrTable,
        columns: [
          { title: 'ID' },
          { title: 'ชื่อทีม' },
          { title: 'สีประจำทีม' },
          { title: 'ดำเนินการ' }
        ],
        dom: 'Bfrtip'
      });

      $('#table_1').on('click', '.btn-edit', (event) => {
        var data = event.currentTarget.value
        that.actionEditteam(data)
      });

      $('#table_1').on('click', '.btn-del', (event) => {
        var data = event.currentTarget.value
        that.actionDelteam(data)
      });

    },
    actionEditteam(teamId) {
      this.teamActionModal()

      const rowData = this.findMasterDataById(teamId)
      this.teamCreateForm = {
        teamName: rowData.name
      }

      this.teamEditMode = 1
      this.teamIdSelect = teamId

    },
    actionDelteam(teamId) {
      this.teamIdSelect = teamId
      Swal.fire({
        title: 'ยืนยันการลบ ?',
        text: "คุณยืนยันการลบทีม ใช่หรือไม่",
        icon: 'question',
        showCancelButton: true,
        confirmButtonColor: '#3699FE',
        cancelButtonColor: '#d33',
        confirmButtonText: 'ยืนยัน',
        cancelButtonText: 'ยกเลิก'
      }).then((result) => {
        if (result.isConfirmed) {
          this.delteam()
        }
      })
    },
    findMasterDataById(id) {
      return this.masterData.find(e => {
        return e._id === id
      })
    },
    teamActionModal() {
      this.clearForm()
      this.$refs["teamActionModal"].show()
    },
    addteam() {
      var raw = JSON.stringify({
        "teamName": this.teamCreateForm.teamName,
        "teamColor": this.teamColor?.hex ? this.teamColor.hex : this.teamColor
      });

      FetchService.post("/addteam", raw, res => {
        Swal.fire(
          'สำเร็จ',
          'บันทึกข้อมูลแล้ว',
          'success'
        )
        this.getDataTable()
        this.$refs["teamActionModal"].hide()
      })

    },
    editteam() {
      var raw = JSON.stringify({
        "teamName": this.teamCreateForm.teamName,
        "teamColor": this.teamColor?.hex ? this.teamColor.hex : this.teamColor
      });

      FetchService.post(`/editteam/${this.teamIdSelect}`, raw, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'แก้ไขข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.$refs["teamActionModal"].hide()
      })
    },
    delteam() {
      FetchService.get(`/deleteteam/${this.teamIdSelect}`, res => {
        console.log(res)

        Swal.fire(
          'สำเร็จ',
          'ลบข้อมูลแล้ว',
          'success'
        )

        this.getDataTable()
        this.$refs["teamActionModal"].hide()
      })
    },
    clearForm() {
      this.teamCreateForm = {
        teamName: "",
        address: "",
        address2: "",
        subDistrict: "",
        district: "",
        province: "",
        postCode: "",
        taxId: "",
      }
      this.teamEditMode = 0
    },
    confirmActionteam() {
      if (this.teamCreateForm.teamName == "") {
        const msg = `กรุณาระบุชื่อทีม`
        Swal.fire(
          'มีข้อผิดพลาด',
          msg,
          'error'
        )
      } else {
        if (this.teamEditMode === 1) {
          Swal.fire({
            title: 'ยืนยันการแก้ไข ?',
            text: "คุณยืนยันการแก้ไขทีม ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.editteam()
            }
          })
        } else {
          Swal.fire({
            title: 'ยืนยันการบันทึก ?',
            text: "คุณยืนยันการบันทึกทีม ใช่หรือไม่",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#3699FE',
            cancelButtonColor: '#d33',
            confirmButtonText: 'ยืนยัน',
            cancelButtonText: 'ยกเลิก'
          }).then((result) => {
            if (result.isConfirmed) {
              this.addteam()
            }
          })
        }
      }
    }
  }
}
</script>

<style>
.bg-plans-form {
  background-color: #FFFFFF;
  border-radius: 10px;
  padding: 20px;
  font-size: 1rem;
  font-weight: 500;
}

input,
label {
  margin: 0.5rem 0;
}

#table_1 table {
  border-collapse: separate;
  border-spacing: 0;
}

#table_1 th {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

.dataTables_wrapper .dataTable thead th {
  border-top: solid 1px #DEDFE0;
  background-color: #f9fafb;
}


#table_1 thead tr:first-child th:first-child {
  border-top-left-radius: 10px;
}

#table_1 thead tr:first-child th:last-child {
  border-top-right-radius: 10px;
}

#table_1 thead tr:first-child th {
  border-top-style: solid;
}

#table_1 thead tr th:first-child {
  border-left-style: solid;
}

#table_1 td {
  border: solid 1px #DEDFE0;
  border-style: none solid solid none;
  padding: 10px;
}

#table_1 tbody th {
  border-style: none solid solid solid;
}

#table_1 tbody tr:first-child td:first-child {
  /* border-top-left-radius: 10px; */
}

#table_1 tbody tr:first-child td:last-child {
  /* border-top-right-radius: 10px; */
}

#table_1 tbody tr:last-child td:first-child {
  border-bottom-left-radius: 10px;
}

#table_1 tbody tr:last-child td:last-child {
  border-bottom-right-radius: 10px;
}

#table_1 tbody tr:first-child td {
  border-top-style: solid;
}

#table_1 tbody tr td:first-child {
  border-left-style: solid;
}

#table_1 tbody tr:first-child td:first-child.dataTables_empty {
  border-top-left-radius: 0px;
}

#table_1 tbody tr:first-child td:last-child.dataTables_empty {
  border-top-right-radius: 0px;
}

table.dataTable thead .sorting:before,
table.dataTable thead .sorting_asc:before,
table.dataTable thead .sorting_desc:before {
  content: "" !important;
}

table.dataTable thead .sorting:after {
  content: "" !important;
}

table.dataTable thead .sorting_asc:after {
  content: "▲" !important;
  content: "▲" /"" !important;
}

table.dataTable thead .sorting_desc:after {
  content: "▼" !important;
  content: "▼" /"" !important;
}

table.dataTable tr.dtrg-group th {
  background-color: #f2f2f2;
  text-align: left;
}

#table_1 tbody tr:hover {
  background-color: #f5f5f5;
  /* สีที่คุณต้องการเมื่อ hover */
  cursor: pointer;
}

.dt-search {
  text-align: right;
  padding-bottom: 0.85rem;
}

.dt-search {
  text-align: right;
}
</style>